export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getComplaintList: function getComplaintList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaints/list",
        method: "get",
        params: data
      });
    },
    getComplaintListOld: function getComplaintListOld() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/complaint/get",
        method: "get",
        params: data
      });
    },
    setComplaintStatus: function setComplaintStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/complaint/setStatus",
        method: "post",
        data: data
      });
    },
    getComplaintDetail: function getComplaintDetail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaints/detail",
        method: "get",
        params: data
      });
    },
    //设置投诉为已处理中（跟进）
    setInProgress: function setInProgress() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaints/setInProgress",
        method: "post",
        data: data
      });
    },
    //请求补充材料
    requestSupplement: function requestSupplement() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaints/requestSupplement",
        method: "post",
        data: data
      });
    },
    //投诉结案
    complaintsResolve: function complaintsResolve() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaints/resolve",
        method: "post",
        data: data
      });
    },
    // 设为星标
    complaintsSetStar: function complaintsSetStar() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaints/star",
        method: "post",
        data: data
      });
    },
    //搁置
    suspendComplaint: function suspendComplaint() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/complaints/suspend",
        method: "post",
        data: data
      });
    },
    // 意见反馈
    getFeedbackList: function getFeedbackList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user_opinion/get",
        method: "get",
        params: data
      });
    },
    setFeedbackStatus: function setFeedbackStatus() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user_opinion/setStatus",
        method: "post",
        data: data
      });
    },
    setFeedbackRemark: function setFeedbackRemark() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/user_opinion/setRemark",
        method: "post",
        data: data
      });
    },
    complaintIssueReward: function complaintIssueReward() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/complaint/issueReward",
        method: "post",
        data: data
      });
    },
    setComplaintRemark: function setComplaintRemark() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/complaint/setRemark",
        method: "post",
        data: data
      });
    }
  };
});